(() => {
  const root = document.documentElement;
  let finished = false;

  const finish = () => {
    if (finished) return;
    finished = true;
    root.classList.add('enyon-page-loaded');
    root.classList.remove('enyon-page-loading');
  };

  if (document.readyState === 'complete') {
    requestAnimationFrame(finish);
  } else {
    window.addEventListener('load', () => requestAnimationFrame(finish), { once: true });
    window.setTimeout(finish, 6000);
  }

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) finish();
  });
})();
